<template>
  <el-form-item
    label-width="100px"
    :class="{'required': data.isRequired,}"
    :required="data.isRequired"
    style="text-align:left"
  >
    <draggable
      v-model="data.controlValue"
      class="list-group"
      tag="ul"
      v-bind="dragOptions"
      @start="productForm.drag = true"
      @end="productForm.drag = false"
    >
      <transition-group>
        <div class="listitem" v-for="(item, index) in data.controlValue" :key="index+item.key">
          <div style="width:148px;height:148px;overflow:hidden">
            <img
              v-if="item.fileUrl"
              :src="item.fileUrl"
              width="148"
              class="imgSty"
            />
          </div>
          <span class="del" @click="openImageBox(index)">
            <i class="el-icon-delete delIcon" @click.stop="handleRemove(item, data.controlValue)" />
          </span>
        </div>
      </transition-group>
    </draggable>
    <!-- <el-input  v-checkParams="'required'" class="after-error" v-model="data.controlValue" hidden></el-input> -->
    <el-upload
      v-if="data.controlValue.length<10"
      multiple
      ref="load"
      :action="commonServer.uploadFile"
      :headers="{ Authorization: token }"
      :on-success="fileSuccess"
      :on-exceed="handleExceed"
      accept="image/jpg, image/jpeg, image/png"
      list-type="picture-card"
      :auto-upload="true"
      :show-file-list="false"
      :limit="10"
    >
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>
    <image-box ref="imageBox"></image-box>
  </el-form-item>
</template>

<script>
import draggable from 'vuedraggable';
import imageBox from '../imageBox';
import { commonServer } from '@/api/api'
export default {
  name: 'UploadImg',
  components: { draggable, imageBox },
  inject: ['formData'],
  props: {
    data: {
      type: Object,
      required: true
    },
    areaIndex: Number
  },
  data () {
    return {
      commonServer,
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      token: window.localStorage.getItem('token'),
      productForm: {
        currentDelBtn: -1,
        drag: false
      },
      imgList: [],
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    };
  },
  mounted () {
    this.$nextTick(() => {
      let arr = [];
      this.data.controlValue.forEach((v) => {
        arr.push({ key: v.key });
      });
      console.log(this.$refs['load'])
      this.$refs['load'].uploadFiles = arr;
    });
  },
  methods: {
    async fileSuccess (res, file, fileList) {
      if (res.success) {
        const t = setTimeout(() => {
          if (this.data.controlValue.length === 10) {
            this.$message.warning('最多只能上传10张图片!')
          } else {
            this.data.controlValue.push({ key: res.data.fileKey, fileUrl: res.data.fileUrl });
          }
          clearTimeout(t)
        }, 500)
      } else {
        this.$message.error(res.message);
      }
    },
    handleExceed(files, fileList) {
      console.log(files)
      console.log(fileList, '000000')
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    imgListSort () {
      this.data.controlValue.sort((a, b) => {
        var value1 = a.fileName.split('.')[0].slice(-1).toLowerCase();
        var value2 = b.fileName.split('.')[0].slice(-1).toLowerCase();
        if (value1 === value2) { return 0 }
        return value1 < value2 ? '-1' : '1';
      })
    },
    handleRemove (file, fileList) {
      console.log(fileList, 'fileList')
      this.$confirm('删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除数据
        this.data.controlValue.forEach((v, i) => {
          if (v.key === file.key) {
            this.data.controlValue.splice(i, 1);
          }
        });
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    openImageBox (index) {
      if (this.$refs.imageBox) {
        let imageList = []
        for (let i = 0, length = this.data.controlValue.length; i < length; i++) {
          imageList.push({ url: `${this.data.controlValue[i].fileUrl}` })
        }
        this.$refs.imageBox.$emit('open', {
          imageList: imageList,
          index: index
        })
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header{
  padding: 5px 10px;
}
/deep/ .el-dialog__footer{
  padding: 0 10px;
}
/deep/ .el-dialog{
  height: 100%;
}
/deep/ .el-dialog__body {
  height: calc(100% - 70px);
  max-height: 100%;
  padding: 10px 20px;
}
.body{
  width: 100%;
  height: 100%;
}
.title {
  font-size: 13px;
  position: absolute;
  bottom: -33px;
  left: 0;
  right: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.delIcon {
  color: #fff;
  font-size: 20px;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
}
.listitem {
  // max-width: 200px;
  float: left;
  margin-right: 10px;
  margin-left: 3px;
  position: relative;
  margin-bottom: 35px;
}
.listitem:hover .del {
  display: block;
  box-shadow: -6px 4px 3px #ccc;
}
.del {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  display: none;
  cursor: pointer;
  border-radius: 4px;
}
.edit-img{
  color: #fff;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  right: 5px;
}
/deep/.check-box{
  font-size: 13px;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  .el-checkbox__label{
    display: none !important;
  }
}
.copy-btn{
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/uploadImg.vue